import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AssessmentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"assessment"}/>
}
